/**
 * Utility functions for i18n
 */

import { getLanguage } from '@/utils/languageUtils';
import {
  leadStatusLabels,
  vehicleCardStatusLabels,
  fuelTypeLabels,
  transmissionTypeLabels,
  conditionGradeLabels,
} from './labels';

/**
 * Translate technical enum values in event details strings
 * Example: "Bränsletyp: GASOLINE → DIESEL" → "Bränsletyp: Bensin → Diesel"
 * Uses current language to determine which labels to use
 */
export const translateEventDetails = (details: string): string => {
  if (!details) return details;
  
  const lang = getLanguage();
  const fuelLabels = fuelTypeLabels(lang);
  const transmissionLabels = transmissionTypeLabels(lang);
  const conditionLabels = conditionGradeLabels(lang);
  const leadLabels = leadStatusLabels(lang);
  const vehicleCardLabels = vehicleCardStatusLabels(lang);
  
  // Pattern to match enum values in event details
  const enumPatterns = [
    // GASOLINE must precede GAS in the alternation: regex alternation is first-match-wins,
    // so "GAS|GASOLINE" would match the "GAS" prefix of GASOLINE first. (\b would then
    // fail the match and force a retry, but the explicit ordering makes it safe outright.)
    { pattern: /\b(GASOLINE|GAS|DIESEL|ELECTRIC|ETHANOL|HYBRID|PLUG_IN_HYBRID|OTHER)\b/g, labels: fuelLabels },
    { pattern: /\b(AUTOMATIC|MANUAL|SEMI_AUTOMATIC|CVT|OTHER)\b/g, labels: transmissionLabels },
    // LIKE_NEW must precede NEW for the same first-match-wins reason as GASOLINE/GAS above.
    { pattern: /\b(LIKE_NEW|NEW|EXCELLENT|GOOD|NORMAL|FAIR|POOR|RENOVATION_OBJECT|OTHER)\b/g, labels: conditionLabels },
    { pattern: /\b(NEW|CONTACTED|FOLLOW_UP|CONVERTED|LOST)\b/g, labels: leadLabels },
    { pattern: /\b(ACTIVE|INACTIVE|COMPLETED|INCOMPLETE)\b/g, labels: vehicleCardLabels },
  ];
  
  let translated = details;
  for (const { pattern, labels } of enumPatterns) {
    translated = translated.replace(pattern, (match) => {
      return labels[match as keyof typeof labels] || match;
    });
  }
  
  return translated;
};

